/**
 * @file ImpersonationContextPick.tsx
 * @description Выбор кабинета в окне «Войти как…» (phase06; вынесено в
 * phase19.28, чтобы окно с причиной входа осталось ≤ 200 строк): нет
 * кабинетов — предупреждение, один — строкой, несколько — список (компонент
 * select проекта, не нативный).
 */

import { Alert } from "./ui/alert";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import type { AdminUserContext } from "../lib/api-admin-users";

interface Props {
  contexts: AdminUserContext[];
  /** Вход из карточки магазина: «нет кабинета в этом магазине». */
  shopScoped: boolean;
  value: string;
  onChange: (contextId: string) => void;
  disabled: boolean;
}

export function ImpersonationContextPick({ contexts, shopScoped, value, onChange, disabled }: Props) {
  return contexts.length === 0 ? (
    <Alert severity="warning">
      {shopScoped
        ? "У пользователя нет кабинета в этом магазине."
        : "У пользователя нет кабинетов магазинов. Вход разрешён только в кабинеты магазинов."}
    </Alert>
  ) : contexts.length > 1 ? (
    <div className="flex flex-col gap-2">
      <Label htmlFor="ctx-select">Кабинет</Label>
      <Select value={value} onValueChange={(v) => onChange(v ?? "")}>
        <SelectTrigger id="ctx-select" disabled={disabled}>
          <SelectValue placeholder="Выберите кабинет" />
        </SelectTrigger>
        <SelectContent>
          {contexts.map((c) => (
            <SelectItem key={c.id} value={c.id}>
              {c.role.displayName} — {c.shop?.displayName ?? c.shop?.slug ?? "?"}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  ) : (
    <p className="type-body">
      Кабинет: {contexts[0]?.role.displayName} — {contexts[0]?.shop?.displayName}
    </p>
  );
}
